import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeSupplementPrice: (value: Nullable<number>) => void;
}

export const SupplementPriceInput: React.FC<IProps> = React.memo(({ changeSupplementPrice }) => (
	<FormInput
		testId="SupplementPriceInput"
		name="supplementPrice"
		label="signedSupplementPriceLabel"
		min={0}
		precision={0}
		onChangeNumber={changeSupplementPrice}
		type="number"
	/>
));
